<!-- overlay -->
<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <!-- popup card -->
  <div class="bg-white rounded-xl shadow-2xl w-full max-w-lg p-6 relative">
    <!-- header -->
    <span class="text-md font-bold mb-4 text-gray-800">
      {{ data.confirmationMessage || ('Do you want to ' + (data.mode | titlecase) + ' ' + (data.title | removeUnderscore) + '?') }}
    </span>

    <!-- body -->
    <div class="mb-4">
      <!-- info mode -->
      <div *ngIf="data.mode === 'info'" class="bg-gray-100 p-4 rounded-md overflow-auto max-h-60">
        <pre class="text-sm text-gray-700">{{ data.payload | json }}</pre>
      </div>

      <!-- reject/query mode -->
      <div>
        <form [formGroup]="form">
          <ng-container *ngIf="data.mode === 'reject' || data.mode === 'query' || data.mode === 'delete' || data.allowComment">
            <span class="block mb-2 text-gray-600 font-medium"
              >Reason for {{ data.mode }} (optional)</span
            >
            <textarea
              formControlName="reason"
              rows="5"
              class="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter reason..."
            ></textarea>
          </ng-container>

          <ng-container *ngIf="data.service === ServiceCodeEnum.LICENSING">
            <!-- attachment -->
            <span class="block mb-2 text-gray-600 font-medium mt-4">Board Resolution Attachment</span>
            <app-inputs
              [field]="{
                name: 'licensingCommitteeResolution',
                documentCode: DocumentCodeEnum.LICENSING_COMMITEE_RESOLUTION,
                label: 'Attachment',
                type: 'file',
                multiple: false,
                maxFileSizeMb: 5,
              }"
              [group]="form"
            ></app-inputs>
          </ng-container>
        </form>
      </div>

      <!-- optional note -->
      <div *ngIf="data.note" class="text-lg text-gray-500 mt-2">{{ data.note }}</div>
    </div>

    <!-- actions -->
    <div class="flex justify-end gap-2">
      <button
        *ngIf="data.mode === 'reject'"
        class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition"
        (click)="confirmReject()"
      >
        Reject
      </button>

       <button
        *ngIf="data.mode === 'delete'"
        class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition"
        (click)="confirmDelete()"
      >
        Delete
      </button>
      

      <button
        *ngIf="data.mode === 'query'"
        class="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg font-medium transition"
        (click)="sendQuery()"
      >
        Submit Query
      </button>

      <button
        *ngIf="
          data.mode === 'activate' ||
          data.mode === 'suspend' ||
          data.mode === 'deactivate' ||
          data.mode === 'approve' ||
          data.mode === 'book'
        "
        class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition"
        (click)="confirmInfo()"
      >
        Confirm {{ data.mode | titlecase }}
      </button>

      <button
        *ngIf="data.mode === 'review'"
        class="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition text-sm"
        (click)="dialogRef.close({ action: 'approve' })"
      >
        Approve
      </button>

      <button
        *ngIf="data.mode === 'review'"
        class="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition text-sm"
        (click)="dialogRef.close({ action: 'reject' })"
      >
        Reject
      </button>

      <button
        *ngIf="data.mode !== 'review'"
        class="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 rounded-lg font-medium transition"
        (click)="close()"
      >
        Close
      </button>
    </div>

    <!-- close icon -->
    <button
      (click)="close()"
      class="absolute top-3 right-3 text-gray-400 hover:text-gray-600 font-bold text-lg"
    >
      &times;
    </button>
  </div>
</div>
